module.exports = __webpack_public_path__ + "static/img/amex.c92ff9e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/common/creditCards/amex.svg
// module id = eZYM
// module chunks = 2